import React from 'react';
import './DestinationHighlights.css';

function DestinationHighlights({ destination }) {
  return (
    <section className="destination-highlights-section">
      <div className="destination-highlights-container">
        <h2 className="destination-highlights-title">Key Highlights</h2>
        <div className="destination-highlights-grid">
          {destination.highlights.map((highlight, index) => (
            <div key={index} className="highlight-card">
              <div className="highlight-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                  <polyline points="22 4 12 14.01 9 11.01"/>
                </svg>
              </div>
              <p className="highlight-text">{highlight}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default DestinationHighlights;

